import { TenantEntity } from '../TenantEntity'
import { saveManifestVGMInfo, deleteManifestVGMInfo } from '@/api/seaExport/manifestVGMInfo'

export class ManifestVGMInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    this._data.sealNo = sealNo
  }
  get vgmWeight() {
    return this._data.vgmWeight
  }
  set vgmWeight(vgmWeight) {
    this._data.vgmWeight = vgmWeight || 0
  }
  get vgmWeightingMeothd() {
    return this._data.vgmWeightingMeothd
  }
  set vgmWeightingMeothd(vgmWeightingMeothd) {
    this._data.vgmWeightingMeothd = vgmWeightingMeothd
  }
  get vgmLiabilityCompany() {
    return this._data.vgmLiabilityCompany
  }
  set vgmLiabilityCompany(vgmLiabilityCompany) {
    this._data.vgmLiabilityCompany = vgmLiabilityCompany
  }
  get vgmAutoGraph() {
    return this._data.vgmAutoGraph
  }
  set vgmAutoGraph(vgmAutoGraph) {
    this._data.vgmAutoGraph = vgmAutoGraph
  }
  get contactEmail() {
    return this._data.contactEmail
  }
  set contactEmail(contactEmail) {
    this._data.contactEmail = contactEmail
  }
  get grossWeight() {
    return this._data.grossWeight
  }
  set grossWeight(grossWeight) {
    this._data.grossWeight = grossWeight || 0
  }
  get telephone() {
    return this._data.telephone
  }
  set telephone(telephone) {
    this._data.telephone = telephone
  }
  get weighingAddress() {
    return this._data.weighingAddress
  }
  set weighingAddress(weighingAddress) {
    this._data.weighingAddress = weighingAddress
  }
  get weightTime() {
    return this._data.weightTime
  }
  set weightTime(weightTime) {
    this._data.weightTime = weightTime
  }
  get vgmWeightUnit() {
    return this._data.vgmWeightUnit
  }
  set vgmWeightUnit(vgmWeightUnit) {
    this._data.vgmWeightUnit = vgmWeightUnit
  }
  get grossWeightUnit() {
    return this._data.grossWeightUnit
  }
  set grossWeightUnit(grossWeightUnit) {
    this._data.grossWeightUnit = grossWeightUnit
  }
  get manifestInfoUuid() {
    return this._data.manifestInfoUuid
  }
  set manifestInfoUuid(manifestInfoUuid) {
    this._data.manifestInfoUuid = manifestInfoUuid
  }
  static async save(data) {
    return await saveManifestVGMInfo(data).then(res => res.data)
  }
  static async delete(uuid) {
    return await deleteManifestVGMInfo({ uuid }).then(res => res.data)
  }
}
